import filter from "lodash/filter";
import find from "lodash/find";
import isUndefined from "lodash/isUndefined";
import range from "lodash/range";

export const MixinOverviewTimeline = {
  computed: {
    timelineOverviewMarkers() {
      // Two things here.
      // 1. Filter so that only markers within the space are returned.
      // 2. Apply the appropriate level of scale (1, 2, 3, 4, or 15, 30, 45 etc.)
      var duration = this.show.data.audio.duration;
      var startWindowTime = 0;
      var endWindowTime = duration;
      var timespanDuration = duration;
      var markSpacingPixels = this.componentWidth / timespanDuration;
      var spanInterval = Math.round(60 * (2 / markSpacingPixels));
      console.log("spanInterval", spanInterval);
      var acceptable_spans = [
        1,
        5,
        15,
        30,
        60,
        60 * 2,
        60 * 3,
        60 * 5,
        60 * 10,
        60 * 20,
        60 * 30,
        60 * 60,
        60 * 120,
        60 * 240,
        60 * 480
      ];

      spanInterval = find(acceptable_spans, i => {
        return i >= spanInterval;
      });

      console.log(
        "spanInterval",
        spanInterval,
        "componentWidth",
        this.componentWidth
      );

      if (isUndefined(spanInterval)) {
        spanInterval = 1;
      }

      var marks = filter(
        range(Math.floor(startWindowTime), Math.floor(endWindowTime)),
        i => !(i % spanInterval)
      );

      console.log("timelineOverviewMarkers", marks);

      return marks;
    }
  },
  methods: {
    timelineOverviewDragged(obj) {
      if (obj.first || obj.last) {
        if (obj.last) {
          // If the last is triggered without any dragging taken place, gotoAndPlay or gotoAndPause.
          if (!this.timelineOverlayDragging) {
            var parentX = obj.el.getBoundingClientRect().left;
            var time =
              ((obj.clientX - parentX) / this.componentWidth) *
              this.show.data.audio.duration;
            if (this.player_ref.audio_ref.paused) {
              this.player_ref.gotoAndPause(time);
              setTimeout(this.updateTimelinesToCurrentTimeAndCenter, 30);
              setTimeout(this.updateTimelinesToCurrentTimeAndCenter, 100);
            } else {
              this.player_ref.gotoAndPlay(time);
            }
          }
        }
        this.timelineOverlayDragging = false;
        return;
      } else {
        // This is a drag, move that playhead!
        //console.log(obj.deltaX);
        //var secPerPixel = this.show.data.audio.duration / this.componentWidth;
        var dragParentX = obj.el.getBoundingClientRect().left;
        var dragTime =
          ((obj.clientX - dragParentX) / this.componentWidth) *
          this.show.data.audio.duration;
        //console.log(dragTime);
        if (dragTime < 0) {
          dragTime = 0;
        }
        if (this.player_ref.audio_ref.paused) {
          this.player_ref.gotoAndPause(dragTime);
          setTimeout(this.updateTimelinesToCurrentTimeAndCenter, 30);
          setTimeout(this.updateTimelinesToCurrentTimeAndCenter, 100);
        } else {
          this.player_ref.gotoAndPlay(dragTime);
          setTimeout(this.updateTimelinesToCurrentTimeAndCenter, 30);
          setTimeout(this.updateTimelinesToCurrentTimeAndCenter, 100);
        }
        this.timelineOverlayDragging = true;
        //console.log(obj);
      }
    }
  }
};
